/**
 * App-wide stacking contract.
 *
 * GlobalChrome and NavDrawer currently top out at 2000. Anything that claims
 * aria-modal must sit above that entire band so the visible dialog is also
 * the only layer that can receive a pointer. Keep this value in one place;
 * modal components should not guess at whichever chrome number is current.
 */
export const HIGHEST_APP_CHROME_Z_INDEX = 2000;
export const MODAL_OVERLAY_Z_INDEX = HIGHEST_APP_CHROME_Z_INDEX + 100;
